<!--
  "Remaining time" pill shown in the checkout shared top row (above the Order
  Summary stack): icon-first,
  "Remaining time:" label in medium weight,
  countdown value in bold, both in the club brand colour.

  `text-main` (`rgb(var(--default-color))`) rather than a hardcoded blue so the
  pill follows the club's own brand colour instead of one
  fixed blue for every tenant.
-->
<h5
  class="flex justify-center md:justify-end items-center gap-1.5 text-main text-sm">
  <img src="/assets/img/clock-icon-blue.svg" alt="" class="w-[15px] h-[15px]" />
  <span class="font-medium">Remaining time:</span>
  <span class="font-bold">{{ getTimer }}</span>
</h5>
